import type { GetB2bFullyManagedPlanContributionsOneResponse } from '@Common/types/b2b/orders';

export const b2bFullyManagedPlanContributionsTranslations = {
  status: {
    pending: 'En cours',
    paid: 'Payé',
    shares_canceled: 'Annulé',
    funding_failed: 'Échec du paiement',
  } satisfies Record<GetB2bFullyManagedPlanContributionsOneResponse['status'], string>,
  type: {
    campaign_allocation: 'Opération',
    cross_plan_arbitrage: 'Arbitrage',
    employer_matching_contribution: 'Abondement',
    voluntary_deposit: 'Dépots volontaires',
  } satisfies Record<GetB2bFullyManagedPlanContributionsOneResponse['contribution_type'], string>,
};
